
import { images } from "../constants";

const courses = [
    {
    id: 1,
    image: images.course1,
    title: "Islamic Parenting: Nurturing Children",
    content: "Learn essential principles of parenting in Islam to raise righteous, confident, and compassionate children.",
    details: {
        date: "18 January, 2025",
        duration: "3 Months",
        instructor: "Saleem Yousuf",
        skillLevel: "Beginner",
        certificate: "Yes",
        students: "100 Enrolled",
        price: "$100",
    },
    overviews: [
        "Islamic Parenting: Nurturing Children is a comprehensive course focused on the teachings of Islam related to child upbringing. It covers practical methods to instill faith, good manners, and strong character in children through compassionate and knowledgeable parenting."
    ],
    features: [
        "Core Islamic principles of parenting",
        "Teaching moral and spiritual values",
        "Effective communication with children",
        "Balancing discipline and kindness",
        "Strategies to build self-confidence in kids"
    ],
    objectives: [
        "Understand the role of parents in Islamic teachings",
        "Learn techniques to nurture children’s faith and character",
        "Apply Islamic values in everyday parenting challenges",
        "Promote a healthy and loving family environment",
        "Empower children to grow into responsible adults"
    ],
    prerequisites: [
        "Open to parents, guardians, and caregivers",
        "Willingness to learn Islamic teachings on parenting",
        "Commitment to apply course lessons at home",
        "Basic understanding of Islamic beliefs",
        "Desire to improve family wellbeing"
    ],
    curriculum: [
        {
            id: 1,
            heading: "Foundations of Islamic Parenting",
            content: "Overview of parenting concepts in Islam including rights and responsibilities."
        },
        {
            id: 2,
            heading: "Instilling Faith and Values",
            content: "Techniques to teach children about Islam, prayer, and good manners."
        },
        {
            id: 3,
            heading: "Effective Communication",
            content: "Building trust and understanding through positive dialogue with children."
        },
        {
            id: 4,
            heading: "Discipline with Compassion",
            content: "Balancing discipline with mercy, avoiding harshness while maintaining respect."
        },
        {
            id: 5,
            heading: "Raising Confident Children",
            content: "Encouraging self-esteem and social skills within Islamic framework."
        },
    ],
    reviews: [
        {
            id: 1,
            image: images.course1Comment1,
            name: "Fatima Noor",
            date: "November 5, 2024",
            rating: 5,
            content: "This course helped me understand how to balance discipline with love while teaching my children about Islam."
        },
        {
            id: 2,
            image: images.course1Comment2,
            name: "Ahmed Ali",
            date: "November 8, 2024",
            rating: 4.9,
            content: "Clear explanations and practical advice made it easy to implement Islamic parenting principles at home."
        }
    ],
    },
    {
        id: 2,
        image: images.course2,
        title: "Basics of Islamic Counseling",
        content: "Gain foundational knowledge of Islamic counseling principles to support mental and spiritual wellbeing within the community.",
        details: {
            date: "18 February, 2025",
            duration: "3 Months",
            instructor: "Zakir Khan",
            skillLevel: "Beginner",
            certificate: "Yes",
            students: "80 Enrolled",
            price: "$90",
        },
        overviews: [
            "Basics of Islamic Counseling introduces students to key counseling techniques grounded in Islamic teachings. This course equips learners to provide empathetic, ethical, and culturally sensitive support aligned with Islamic values."
        ],
        features: [
            "Foundations of counseling in Islam",
            "Understanding mental health from an Islamic perspective",
            "Communication skills and active listening",
            "Ethical considerations in counseling",
            "Practical counseling scenarios"
        ],
        objectives: [
            "Understand the role and importance of counseling in Islam",
            "Learn effective communication and listening skills",
            "Identify common mental health issues and their Islamic context",
            "Apply Islamic ethics to counseling situations",
            "Support individuals and families through empathetic guidance"
        ],
        prerequisites: [
            "Interest in mental health and Islamic teachings",
            "Basic knowledge of Islam",
            "Willingness to engage in practical exercises",
            "Commitment to ethical counseling practices",
            "Open mind to diverse counseling scenarios"
        ],
        curriculum: [
            {
                id: 1,
                heading: "Introduction to Islamic Counseling",
                content: "Understanding the foundations and significance of counseling in the Islamic context."
            },
            {
                id: 2,
                heading: "Mental Health and Islam",
                content: "Exploring mental health issues through Islamic teachings and perspectives."
            },
            {
                id: 3,
                heading: "Effective Communication Skills",
                content: "Building rapport and practicing active listening for successful counseling."
            },
            {
                id: 4,
                heading: "Ethical Guidelines in Counseling",
                content: "Applying Islamic ethics and confidentiality principles during counseling."
            },
            {
                id: 5,
                heading: "Case Studies and Role Playing",
                content: "Engaging with practical scenarios to develop counseling skills."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course2Comment1,
                name: "Aisha Khan",
                date: "December 10, 2024",
                rating: 5,
                content: "An insightful course that combines Islamic principles with practical counseling techniques."
            },
            {
                id: 2,
                image: images.course2Comment2,
                name: "Omar Farooq",
                date: "December 12, 2024",
                rating: 4.8,
                content: "Highly recommended for anyone interested in helping others through Islamic counseling."
            }
        ],
    },
    {
        id: 3,
        image: images.course3,
        title: "Art and Calligraphy in Islamic Tradition",
        content: "Explore the rich heritage of Islamic art and calligraphy, learning traditional techniques and cultural significance.",
        details: {
            date: "10 March, 2025",
            duration: "2 Months",
            instructor: "Shumaila Mushtaq",
            skillLevel: "Beginner to Intermediate",
            certificate: "Yes",
            students: "60 Enrolled",
            price: "$80",
        },
        overviews: [
            "This course delves into the history and techniques of Islamic art and calligraphy. Students will learn various styles, tools, and the cultural meanings behind this revered artistic tradition."
        ],
        features: [
            "History of Islamic art",
            "Styles of Islamic calligraphy",
            "Techniques and tools used",
            "Symbolism and cultural context",
            "Hands-on calligraphy practice"
        ],
        objectives: [
            "Understand the origins and evolution of Islamic art",
            "Identify different calligraphy styles and their uses",
            "Master basic calligraphy techniques",
            "Appreciate the cultural and spiritual significance of Islamic art",
            "Create original calligraphy artworks"
        ],
        prerequisites: [
            "Basic drawing skills",
            "Interest in Islamic culture and art",
            "Patience and attention to detail",
            "Willingness to practice regularly",
            "Open to learning new artistic methods"
        ],
        curriculum: [
            {
                id: 1,
                heading: "Introduction to Islamic Art",
                content: "Overview of Islamic art history, major periods, and styles."
            },
            {
                id: 2,
                heading: "Foundations of Calligraphy",
                content: "Basic principles and techniques of Islamic calligraphy."
            },
            {
                id: 3,
                heading: "Calligraphy Styles and Scripts",
                content: "Explore popular scripts such as Kufic, Naskh, and Thuluth."
            },
            {
                id: 4,
                heading: "Tools and Materials",
                content: "Learn about traditional calligraphy pens, inks, and papers."
            },
            {
                id: 5,
                heading: "Practical Calligraphy Exercises",
                content: "Hands-on practice to develop skills and style."
            },
        ],
        reviews: [
            {
                id: 1,
                image: images.course3Comment1,
                name: "Sara Ali",
                date: "January 15, 2025",
                rating: 5,
                content: "A beautiful introduction to Islamic calligraphy, very informative and inspiring."
            },
            {
                id: 2,
                image: images.course3Comment2,
                name: "Hassan Ahmed",
                date: "January 20, 2025",
                rating: 4.7,
                content: "The course helped me appreciate the depth of Islamic art traditions."
            }
        ],
    },
    {
        id: 4,
        image: images.course4,
        title: "History and Civilization of Islam",
        content: "Discover the rich history and development of Islamic civilization from its beginnings to modern times.",
        details: {
            date: "5 April, 2025",
            duration: "3 Months",
            instructor: "Shahnaz Sohail",
            skillLevel: "Beginner to Advanced",
            certificate: "Yes",
            students: "120 Enrolled",
            price: "$90",
        },
        overviews: [
            "This comprehensive course covers the rise of Islam, key historical events, cultural advancements, and contributions of Islamic civilization across centuries."
        ],
        features: [
            "Origins and early history of Islam",
            "The Golden Age of Islamic civilization",
            "Cultural and scientific contributions",
            "Major Islamic empires and dynasties",
            "Islam in the modern world"
        ],
        objectives: [
            "Trace the origins and spread of Islam",
            "Understand major historical milestones",
            "Analyze cultural and scientific achievements",
            "Recognize the role of Islamic empires",
            "Reflect on Islam’s impact in contemporary times"
        ],
        prerequisites: [
            "Interest in history and culture",
            "Basic reading and comprehension skills",
            "Curiosity about Islamic traditions",
            "Willingness to engage in discussions",
            "Open mindset to diverse perspectives"
        ],
        curriculum: [
            {
            id: 1,
            heading: "Foundations of Islam",
            content: "Exploring the life of Prophet Muhammad (PBUH) and early Islamic community."
            },
            {
            id: 2,
            heading: "The Rashidun and Umayyad Caliphates",
            content: "Key events and developments during the first two caliphates."
            },
            {
            id: 3,
            heading: "The Abbasid Era and Islamic Golden Age",
            content: "Cultural, scientific, and intellectual flourishing."
            },
            {
            id: 4,
            heading: "Ottoman, Safavid, and Mughal Empires",
            content: "Major Islamic empires and their contributions."
            },
            {
            id: 5,
            heading: "Islam in the Contemporary World",
            content: "Modern challenges and global Islamic presence."
            },
        ],
        reviews: [
            {
            id: 1,
            image: images.course4Comment1,
            name: "Layla Hassan",
            date: "March 10, 2025",
            rating: 5,
            content: "Excellent course! It gave me a deep understanding of Islamic history."
            },
            {
            id: 2,
            image: images.course4Comment2,
            name: "Omar Siddiqui",
            date: "March 15, 2025",
            rating: 4.8,
            content: "Very detailed and engaging lectures with great resources."
            }
        ],
    },
    {
    id: 5,
    image: images.course5,
    title: "Biography of Prophet Muhammad (PBUH)",
    content: "A detailed study of the life, teachings, and legacy of the Prophet Muhammad (PBUH), the final messenger of Islam.",
    details: {
        date: "10 May, 2025",
        duration: "2 Months",
        instructor: "Saleem Yousuf",
        skillLevel: "Beginner",
        certificate: "Yes",
        students: "150 Enrolled",
        price: "$85",
    },
    overviews: [
        "This course explores the early life, prophethood, challenges, and achievements of Prophet Muhammad (PBUH), highlighting his role in shaping Islamic beliefs and practices."
    ],
    features: [
        "Early life and upbringing",
        "Revelation and mission",
        "Key events and battles",
        "Teachings and ethics",
        "Legacy and influence"
    ],
    objectives: [
        "Understand the historical context of the Prophet’s life",
        "Explore the major events in his prophethood",
        "Learn about his ethical teachings",
        "Recognize his impact on Islamic faith and culture",
        "Appreciate his role as a spiritual and social leader"
    ],
    prerequisites: [
        "Basic knowledge of Islamic concepts",
        "Interest in religious studies",
        "Open mind to learn about Prophet’s life",
        "Willingness to reflect on teachings",
        "Commitment to course participation"
    ],
    curriculum: [
        {
        id: 1,
        heading: "Early Life and Family Background",
        content: "Explore the childhood and family lineage of the Prophet Muhammad (PBUH)."
        },
        {
        id: 2,
        heading: "Call to Prophethood",
        content: "Understand the first revelations and the beginning of his mission."
        },
        {
        id: 3,
        heading: "Challenges and Opposition",
        content: "Learn about the hardships faced during the early years of Islam."
        },
        {
        id: 4,
        heading: "Migration to Medina",
        content: "Study the Hijra and establishment of the Muslim community."
        },
        {
        id: 5,
        heading: "Final Years and Legacy",
        content: "Reflect on the Prophet’s last years and enduring influence."
        },
    ],
    reviews: [
        {
        id: 1,
        image: images.course5Comment1,
        name: "Ayesha Khan",
        date: "April 12, 2025",
        rating: 5,
        content: "A deeply insightful course that helped me connect more with the life of the Prophet."
        },
        {
        id: 2,
        image: images.course5Comment2,
        name: "Bilal Ahmed",
        date: "April 15, 2025",
        rating: 4.9,
        content: "Well-structured lessons and engaging instructor."
        }
    ],
    },
    {
    id: 6,
    image: images.course6,
    title: "Beginner’s Guide to Arabic Language",
    content: "Learn the basics of the Arabic language, including alphabet, pronunciation, and simple vocabulary essential for understanding Islamic texts.",
    details: {
        date: "5 June, 2025",
        duration: "3 Months",
        instructor: "Zakir Khan",
        skillLevel: "Beginner",
        certificate: "Yes",
        students: "120 Enrolled",
        price: "$70",
    },
    overviews: [
        "This course provides a comprehensive introduction to Arabic language fundamentals, helping students build a strong foundation for further study and understanding of Islamic scripture."
    ],
    features: [
        "Arabic Alphabet and Pronunciation",
        "Basic Grammar and Sentence Structure",
        "Common Vocabulary and Phrases",
        "Reading Practice with Simple Texts",
        "Introduction to Islamic Terms"
    ],
    objectives: [
        "Recognize and write Arabic letters",
        "Understand basic sentence construction",
        "Pronounce Arabic words correctly",
        "Build foundational vocabulary",
        "Gain confidence in reading simple Arabic texts"
    ],
    prerequisites: [
        "No prior knowledge of Arabic required",
        "Interest in learning Arabic",
        "Motivation to practice regularly",
        "Basic understanding of English",
        "Willingness to engage with course materials"
    ],
    curriculum: [
        {
        id: 1,
        heading: "Arabic Alphabet",
        content: "Learn the shapes and sounds of Arabic letters."
        },
        {
        id: 2,
        heading: "Basic Grammar",
        content: "Introduction to sentence structure and grammar rules."
        },
        {
        id: 3,
        heading: "Vocabulary Building",
        content: "Learn common words and everyday phrases."
        },
        {
        id: 4,
        heading: "Reading Practice",
        content: "Simple texts for reading and comprehension."
        },
        {
        id: 5,
        heading: "Islamic Terminology",
        content: "Basic Islamic terms and their meanings."
        },
    ],
    reviews: [
        {
        id: 1,
        image: images.course6Comment1,
        name: "Sara Malik",
        date: "July 10, 2025",
        rating: 5,
        content: "Perfect for beginners! The lessons are clear and easy to follow."
        },
        {
        id: 2,
        image: images.course6Comment2,
        name: "Omar Hussain",
        date: "July 12, 2025",
        rating: 4.8,
        content: "Helped me understand Arabic basics quickly and effectively."
        }
    ],
    }

];

export default courses;